import { forwardRef } from 'react';
import cx from 'clsx';

import mapPropsToStyles from '~utils/map-props-to-styles';

import $ from './button.scss';

interface iProps extends React.ComponentPropsWithoutRef<'button'> {
    label: string | JSX.Element;
    size?: 'medium';
    /**
     * Visual style of the button.
     * - solid: filled button
     * - outline: stroked button
     */
    variant?: 'solid' | 'outline';
    /**
     * @deprecated Prefer `variant`. Kept for backward compatibility.
     * primary -> solid, secondary -> outline
     */
    color?: 'primary' | 'secondary';
}

export type ButtonProps = iProps;

export const Button = forwardRef<HTMLButtonElement, iProps>(
    (
        {
            label,
            className,
            size = 'medium',
            variant,
            color = 'primary',
            type = 'button',
            ...props
        },
        ref,
    ) => {
        const derivedVariant: NonNullable<iProps['variant']> =
            variant ?? (color === 'secondary' ? 'outline' : 'solid');

        return (
            <button
                className={cx(mapPropsToStyles({ size, variant: derivedVariant }, $), className)}
                type={type}
                ref={ref}
                {...props}
            >
                {label}
            </button>
        );
    },
);
